export default "__VITE_ASSET__KZD88wWv__"